import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { ClickedElement } from '../../avatar-search';
import { SearchAgGrid } from '../../bodisplay';
import { StageService } from '../../formation/stage-modal/stage-onglet/services/stage-modal.service';
import { BObjectModel, CRUD, QResult, QueovalItem } from '../../models';
import { DataEffectif, EffectifModel } from '../../models/effectif/effectif.model';
import { GenericEffectif } from '../../models/effectif/genericEffectif.model';
import { ModeEffectifUpdate, RenderType, SelectionMode } from '../../models/effectif/option.model';
import { CoreService, HttpService } from '../../services';
import { ToastService } from '../../toast';
import { EffectifsService } from '../effectifs.service';

@Component({
  selector: 'effectifs-manager',
  templateUrl: './effectifs-manager.component.html',
  styleUrls: ['./effectifs-manager.component.css']
})
export class EffectifsManagerComponent implements OnInit {

  public CRUD = CRUD;
  public RenderType = RenderType;
  public selectionMode = SelectionMode;

  public inputValue: string = '';

  public EffectifSelected: GenericEffectif;

  public modelForQSearch: SearchAgGrid;

  public ShowCustomerDropdown: boolean = false;

  public externalService: EffectifsService | null = null;
  @Input('externalService') set SetExternalService(value: EffectifsService) {
    this.externalService = value;
  }

  //rajouter un output pour dire aux autres composant de se refresh

  constructor(
    public service: EffectifsService,
    public Stageservice: StageService,
    protected http: HttpService,
    protected indParam: CoreService,
    protected modalService: NgbModal,
    private toast: ToastService,
  ) { }

  ngOnInit(): void {

    this.modelForQSearch = new SearchAgGrid();
    this.modelForQSearch.CodeRelation = this.service.EffectifModel.SelectedData.Relation;
    this.modelForQSearch.IdDonnee = this.service.EffectifModel.SelectedData.IdOrigin;
    this.modelForQSearch.Mode = 'LINK';
    this.modelForQSearch.Origin = 'PERE';

    //if (this.service.Options.Title != "Préinscrits" && this.service.Options.Title != "Clients") {
    //  this.service.isLoading = true;
    //  this.service.EffectifModel.Mode = "GETAVAILABLEEFFECTIF";

    //  this.http.postHttp(`${this.indParam.AppParams.apiUrl}api/effectifs/postData`, this.service.EffectifModel).subscribe((data: EffectifModel) => {
    //    this.service.EffectifModel.DataListAll = data.DataListAll;
    //    this.service.isLoading = false;
    //  });
    //}
  }

  /** Empecher la fermeture à n'importe quel clique
 * 
 * @param event
 */
  stopPropagation(event: Event) {
    event.stopPropagation();
  }


  /** Fermeture automatique des menus
 * 
 * @param event
 */
  @HostListener('document:click')
  close() {
    this.ShowCustomerDropdown = false;

  }

  public OnPopoverIsClosed(): void {
    this.inputValue = '';
  }

  public ChangeShowCustomerDropdown() {
    this.ShowCustomerDropdown = !this.ShowCustomerDropdown;
  }

  // Liste des elements selectionnés pour le tooltip
  public GetListElement(): string {
    let elements: string = '';
    if (this.service?.EffectifModel?.DataListSelect) {
      this.service.EffectifModel.DataListSelect.forEach((item: GenericEffectif) => {
        elements = item && item.Text ? elements ? `${elements}\n${item.Text}` : item.Text : elements;
      });
    }
    return elements;
  }

  public AddAll(): void {
    this.service.EffectifModel.Mode = "INSERTLIEN";
    this.service.EffectifModel.ListIdEffectifsToMove = this.service.EffectifModel.DataListAll.map(eff => eff.Id);
    this.http.postHttp(`${this.indParam.AppParams.apiUrl}api/effectifs/postData`, this.service.EffectifModel).subscribe((data: EffectifModel) => {

      if (!data.HasError) {
        //this.service.loadData();

        this.service.EffectifModel.DataListSelect = this.service.EffectifModel.DataListSelect.concat(this.service.EffectifModel.DataListAll);

        this.service.EffectifModel.DataListAll = new Array<GenericEffectif>();

        this.service.EffectifModel.DataListSelect.sort((a, b) => {
          if (a.Text > b.Text) {
            return 1;
          }
          if (a.Text < b.Text) {
            return -1;
          }
          return 0;
        });

      }
    });
  }

  public UnselectAll(): void {
    this.service.EffectifModel.Mode = "DELETELIEN";
    this.service.EffectifModel.IdEffectifToMove = "";
    this.service.EffectifModel.ListIdEffectifsToMove = this.service.EffectifModel.DataListSelect.map(eff => eff.Id);
    this.http.postHttp(`${this.indParam.AppParams.apiUrl}api/effectifs/postData`, this.service.EffectifModel).subscribe((data: EffectifModel) => {

      if (!data.HasError) {
        //this.service.loadData();
        if (this.service.Options.RenderType != RenderType.PMSTAGE) {
          this.service.EffectifModel.DataListAll = this.service.EffectifModel.DataListAll.concat(this.service.EffectifModel.DataListSelect);


          this.service.EffectifModel.DataListAll.sort((a, b) => {
            if (a.Text > b.Text) {
              return 1;
            }
            if (a.Text < b.Text) {
              return -1;
            }
            return 0;
          });
        }
        this.service.loadData();
        this.Stageservice.SetRefresh();
      }
    });
  }

  public AddEffectifToSelect(effectif: any) {
    if (effectif.constructor.name == QueovalItem.name) {
      return;
    } else {

      this.service.EffectifModel.Mode = "INSERTLIEN";
      // effectif.Id n'existe pas dans le cas d'une personne morale, l'id de l'effectif est stocké dans Value
      if (this.service.EffectifModel.RenderType == RenderType.PMSTAGE || this.service.EffectifModel.RenderType == RenderType.PM) {
        this.service.EffectifModel.IdEffectifToMove = effectif.Value;
      } else {
        this.service.EffectifModel.IdEffectifToMove = effectif.Id;
      }
      this.http.postHttp(`${this.indParam.AppParams.apiUrl}api/effectifs/postData`, this.service.EffectifModel).subscribe((data: EffectifModel) => {

        if (!data.HasError) {
          this.service.EffectifModel.DataListSelect.push(effectif);
          this.service.EffectifModel.DataListSelect.sort((a, b) => {
            if (a.Text > b.Text) {
              return 1;
            }
            if (a.Text < b.Text) {
              return -1;
            }
            return 0;
          });
          if (this.service.Options.RenderType != RenderType.PMSTAGE) {
            this.service.EffectifModel.DataListAll = this.service.EffectifModel.DataListAll.filter(eff => eff.Id != effectif.Id).map(eff => { return eff });
          } else {
            if (data.HasAlert) {

              this.toast.showInfoToast(data.Alert);
            }
          }

          this.service.EffectifModel.DataListSelect = [...this.service.EffectifModel.DataListSelect];

          //this.service.loadData();
          this.Stageservice.SetRefresh();
        }
      });
    }
  }

  public InsertLienEffectif(event: BObjectModel, modal: any) {

    const newEffectif: DataEffectif = new DataEffectif();

    // On garde les anciennes relation et idOrigin avant de faire les modifs
    // afin qu'après le loadData le render des contact ne soit pas uniquement sur le client qu'on vient de modifier

    const oldRelation = this.service.EffectifModel.SelectedData.Relation;

    const oldIdOrigin = this.service.EffectifModel.SelectedData.IdOrigin;

    newEffectif.BoName = event.NameBO;

    this.service.EffectifModel.IdEffectifToMove = event.IdDonneeFils;

    this.service.EffectifModel.Mode = "INSERTLIEN";

    //vérifier que si on est dans un bo_contact, car nécéssite plus de lien crée
    if (this.service.EffectifModel.AllData.Relation == "REL_BO_CSOC_BO_CONTACT") {
      this.service.EffectifModel.SelectedData.OriginLink = '';
      this.http.postHttp(`${this.indParam.AppParams.apiUrl}api/effectifs/postData`, this.service.EffectifModel).subscribe((data: EffectifModel) => {

        if (!data.HasError) {
          // Réaffectation de la relation et de l'id origin pour lié le contact au client
          this.service.EffectifModel.SelectedData.OriginLink = 'FILS';
          this.service.EffectifModel.SelectedData.Relation = this.service.EffectifModel.AllData.Relation;
          this.service.EffectifModel.SelectedData.IdOrigin = this.service.EffectifModel.AllData.IdOrigin;
          this.http.postHttp(`${this.indParam.AppParams.apiUrl}api/effectifs/postData`, this.service.EffectifModel).subscribe(() => {

            this.service.EffectifModel.SelectedData.OriginLink = '';
            this.service.EffectifModel.SelectedData.Relation = oldRelation;
            this.service.EffectifModel.SelectedData.IdOrigin = oldIdOrigin;
            this.service.EffectifModel.AllData.IdOrigin = '';

            this.Stageservice.SetRefresh();
            //this.service.loadData();

            modal.dismiss();

          });
        }
      });
    } else {
      // Autre lien Client ou Formateur sur Stage      
      this.http.postHttp(`${this.indParam.AppParams.apiUrl}api/effectifs/postData`, this.service.EffectifModel).subscribe((data: EffectifModel) => {
        
          this.service.EffectifModel.SelectedData.OriginLink = '';
          this.service.EffectifModel.SelectedData.Relation = oldRelation;
          this.service.EffectifModel.SelectedData.IdOrigin = oldIdOrigin;
          this.service.EffectifModel.AllData.IdOrigin = '';

          this.Stageservice.SetRefresh();
          //this.service.loadData();

          modal.dismiss();
        
      });
    }
  }

  public CreateClientInd(event: BObjectModel, modal: any) {
    this.service.EffectifModel.Mode = "CREATE_CLIENT_IND";

    this.service.EffectifModel.IdEffectifToMove = event.IdDonneeFils;

    this.http.postHttp(`${this.indParam.AppParams.apiUrl}api/effectifs/postData`, this.service.EffectifModel).subscribe((data: EffectifModel) => {

      if (!data.HasError) {
        this.Stageservice.SetRefresh();
        this.service.loadData();
      }
    });

    modal.dismiss();

  }

  public RefreshComponentAfterAdd(success: boolean) {
    if (success) {
      this.modalService.dismissAll();
      this.service.loadData();
      this.Stageservice.SetRefresh();
    }
  }

  // #region GestionModal

  // Ouverture de la modal pour consulter/update le bo de l'effectif
  open(Modal: any, identEffectif: string) {
    this.service.Model.IdDonneeFils = identEffectif;
    if (this.service.EffectifModel.AllData.Relation == "REL_BO_CSOC_BO_CONTACT") {
      if (this.service.EffectifModel.DataListFilter?.length == 1) {
        this.service.EffectifModel.AllData.IdOrigin = this.service.EffectifModel.DataListFilter[0].Id;
      }
    }

    this.modalService.open(Modal, { centered: true, size: 'q-xxl', windowClass: 'qmodalover' }).result.then(() => {
    }, (reason) => {

      this.service.loadData();
    });

  }

  public openModalClientInd(Modal: any) {
    // pour que le contact crée soit par défaut contact principal du client Ind qu'on crée a partir de ce contact
    this.service.EffectifModel.IsContactPrincipal = true;

    // on fait ca afin que le bo qui s'ouvre soit le bo contact même si on est dans le cadre client avec du coup un model bo construit pour ouvrir un bo client
    this.service.Model.IdDonneeFils = "0";
    this.service.Model.NameBO = 'BO_CONTACT';
    this.service.Model.CodeRelation = "REL_BO_CENT_BO_CONTACT";
    this.service.Model.IdRelation = "";
    this.service.Model.IdentBO = "";


    this.modalService.open(Modal, { centered: true, size: 'q-xxl', windowClass: 'qmodalover' }).result.then(() => {
    }, (reason) => {

      this.service.loadData();
    });
  }

  openModalSpe(Modal: any, Size: string = 'q-xxl') {

    this.modalService.open(Modal, { centered: true, size: Size, windowClass: 'qmodalover' });
  }

  public closeModal() {
    if (this.service.Model.NameBO == 'BO_CONTACT') {
      this.service.EffectifModel.AllData.IdOrigin = '';
      this.service.loadData();
    }
    this.modalService.dismissAll();
  }

  //#endregion GestionModal

  // #region Client/Contact

  public GetContactForClient(value: string) {
    this.service.EffectifModel.AllData.IdOrigin = value;
    this.service.EffectifModel.SelectedData.OriginLink = "FILS";
  }

  // #endregion Client/Contact
}

